<template>
  <div>
    <v-stepper-step :complete="step > stepConfig" step="!">
      Dados CID - Classificação Internacional de Doenças e Problemas
      Relacionados à Saúde
      <v-chip
        small
        v-if="step > stepConfig && atestadoEnviar.cid != ''"
        class="mt-1"
      >
        {{ getCidCompleta() }}
      </v-chip>
    </v-stepper-step>
    <v-stepper-content :step="stepConfig">
      <v-card flat>
        <v-card-text class="pt-0 pb-0">
          <v-autocomplete
            label="Código do CID"
            v-model="atestadoEnviar.cid"
            :items="cids"
            :item-text="textCid"
            item-value="codigo"
            no-data-text="Nenhum CID encontrado"
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <botoes-stepper />
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BotoesStepper from "./BotoesStepper.vue";
export default {
  components: { BotoesStepper },
  computed: mapState("atestado", ["atestadoEnviar", "cids", "step"]),
  data: () => ({
    stepConfig: 50,
  }),
  methods: {
    ...mapGetters("atestado", ["getCidCompleta"]),
    textCid(item) {
      if (item.codigo != "") return `${item.codigo} - ${item.descricao}`;
      else return "";
    },
  },
};
</script>

<style>
</style>